import { Component, OnInit } from '@angular/core';
import { ServerService } from 'src/app/services/server.service';
import { MediaPlanRequestCommentComponent } from './media-plan-request-comment/media-plan-request-comment.component';
import { CreateMediaPlanRequestComponent } from './create-media-plan-request/create-media-plan-request.component';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA, MatDialogConfig, MatPaginator } from '@angular/material';
import { CreateMediaPlanComponent } from './create-media-plan/create-media-plan.component';
import { ViewMediaPlanComponent } from './view-media-plan/view-media-plan.component';
import { ViewMediaPlanRequestComponent } from './view-media-plan-request/view-media-plan-request.component';
import { CancelledStatusComponent } from './cancelled-status/cancelled-status.component';
import { EditMediaPlanRequestComponent } from './edit-media-plan-request/edit-media-plan-request.component';
import { EditMediaPlanComponent } from './edit-media-plan/edit-media-plan.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-media-plan',
  templateUrl: './media-plan.component.html',
  styleUrls: ['./media-plan.component.scss'],
  
})
export class MediaPlanComponent implements OnInit {
  userInfo = JSON.parse(localStorage.getItem('userInfo'))
  token = localStorage.getItem('token')
 
  showComponentLoader = true;
  elasticSearch:any ='';
  updatedAt:any;
  createdAt:any;
  selectedPlanType:any;
  selectedStatus:any;
  selectedRequestType:any;
  selectedPriority:any;
  myDateRangePickerOptions = {
    dateFormat: 'dd.mm.yyyy'
  };

  media_plan_request_data:any;
  media_plan_requests:any
  media_plan_requests_status_count:any;
  // expandedIndex: number | null = null;
  expandedRows: number[] = [];
  media_plan_all_info:any;
  pageIndex: number = 0;
  pageSize: number = 100;
  allIsActive:boolean=true;
  isFilterApplied = false;
  mediaPlanRequestCommentComponent: MatDialogRef<MediaPlanRequestCommentComponent>;
  createMediaPlanRequestComponent : MatDialogRef<CreateMediaPlanRequestComponent>;
  createMediaPlanComponent : MatDialogRef<CreateMediaPlanComponent>;
  viewMediaPlanComponent: MatDialogRef<ViewMediaPlanComponent>
  viewMediaPlanRequestComponent:MatDialogRef<ViewMediaPlanRequestComponent>
  cancelledStatusComponent:MatDialogRef<CancelledStatusComponent>
  editMediaPlanRequestComponent:MatDialogRef<EditMediaPlanRequestComponent>
  editMediaPlanComponent:MatDialogRef<EditMediaPlanComponent>
  requestType = ['Quick CPL','Detailed Media Plan']

  assignedUserList:any;
  selectedAssignedTo:any;
  constructor(
    private _serverService:ServerService,
    private dialog: MatDialog,
    private _router:Router
  ) { 
    // console.log(this.userInfo)
  }
  ngOnInit() {
    this.getCommonData();
    this.getListOfMediaPlan();
    this.getAssignUser();
  }
  CommaInNumber(number: any) {
 
    if(number != null){
      number = Number(number)
      let temp = number.toLocaleString("en-IN");
      return temp;
    }
  }
  getNext(event:any){
    let body1 = {
      "per_page": event.pageSize,
      "page": event.pageIndex
    };

    // let body = {}
    let body = {}
    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch
    }
    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
    }
    if (this.updatedAt != undefined && this.updatedAt != "") {
      body["updated_at"] = [this.updatedAt.formatted.split(" - ")[0], this.updatedAt.formatted.split(" - ")[1]];
    }
    if (this.selectedPlanType != undefined && this.selectedPlanType != "") {
      body["plan_type"] = this.selectedPlanType;
    }
    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }
    if(this.selectedAssignedTo != undefined && this.selectedAssignedTo != ""){
      body["assigned_to_id"]= this.selectedAssignedTo;
    }
    if (this.selectedRequestType != undefined && this.selectedRequestType != "") {
      if(this.selectedRequestType == 'Quick CPL'){
      body["is_detailed_plan_required"] = false;
      }
      else{
        body["is_detailed_plan_required"] = true;
      }
    }
    if (this.selectedPriority != undefined && this.selectedPriority != "") {
      body["priority"] = this.selectedPriority;
    }
    


    this.pageSize = body1.per_page;
    this.pageIndex = body1.page
    let indexPage = this.pageIndex + 1
    let url = "media_plan_request/index_with_filters?per_page=" + this.pageSize + "&page=" + indexPage;
    this._serverService.getAllMediaPlan(url,body,this.token).subscribe((data)=>{
      this.media_plan_all_info = data
      this.media_plan_requests = data.media_plan_requests;
      this.media_plan_requests_status_count = data.media_plan_requests_status_count;
      this.showComponentLoader = false;
      })

  }
  getCommonData(){
    let url = 'media_plan_request/common_data'
    this._serverService.getMediaPlanCommonData(url,this.token).subscribe((data)=>{
      this.media_plan_request_data = data.media_plan_request_data;
     
    })
  }
  openMediaPlanRequestCommentModal(mediaPlanRequest:any) {
    if(mediaPlanRequest.status.toLowerCase() != 'cancelled'){
    mediaPlanRequest['commentType'] = 'mediaPlanRequest'
      this.mediaPlanRequestCommentComponent = this.dialog.open(MediaPlanRequestCommentComponent, {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: '1020px',
        panelClass: 'cdk-overlay-panel-right-side',
        data: mediaPlanRequest
      });
      this.mediaPlanRequestCommentComponent.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.showComponentLoader = true
          this.getListOfMediaPlan()
        }
      })
    }
    }
  getListOfMediaPlan(isFilter?:any){
    this.showComponentLoader = true;
    if(isFilter=='filter'){
      this.allIsActive = false
      this.isFilterApplied = true;
    }
    let body = {}
    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch
      this.isFilterApplied = true;
    }
    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
      this.isFilterApplied = true;
    }
    if (this.updatedAt != undefined && this.updatedAt != "") {
      body["updated_at"] = [this.updatedAt.formatted.split(" - ")[0], this.updatedAt.formatted.split(" - ")[1]];
      this.isFilterApplied = true;
    }
    if (this.selectedPlanType != undefined && this.selectedPlanType != "") {
      body["plan_type"] = this.selectedPlanType;
      this.isFilterApplied = true;
    }
    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
      this.isFilterApplied = true;
    }
    if(this.selectedAssignedTo != undefined && this.selectedAssignedTo != ""){
      body["assigned_to_id"]= this.selectedAssignedTo;
    }

    if (this.selectedRequestType != undefined && this.selectedRequestType != "") {
      if(this.selectedRequestType == 'Quick CPL'){
      body["is_detailed_plan_required"] = false;
      }
      else{
        body["is_detailed_plan_required"] = true;
      }
    }
    if (this.selectedPriority != undefined && this.selectedPriority != "") {
      body["priority"] = this.selectedPriority;
    }


    // console.log()
    let url = "media_plan_request/index_with_filters?per_page=" + this.pageSize + "&page=" + this.pageIndex;
    this._serverService.getAllMediaPlan(url,body,this.token).subscribe((data)=>{
    this.media_plan_all_info = data
    this.media_plan_requests = data.media_plan_requests;
    this.media_plan_requests_status_count = data.media_plan_requests_status_count;
    this.showComponentLoader = false;
    })
  }
  getAssignUser() {
    this.showComponentLoader = true;

    let url = "/campaign_module/user_list";
    this._serverService.getMM(url, this.token).subscribe(
      (data) => {
        this.assignedUserList = data.data;
        this.assignedUserList.unshift({ id: null, name: "Assigned To" });
        //console.log(this.mmList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        // this.clipBoardService.checkServerError(err, this.token);
      }
    );
  }
  removeSearch(){
   
      this.elasticSearch = ""
      this.getListOfMediaPlan()
    
  }
  create(){
    this.createMediaPlanRequestComponent = this.dialog.open(CreateMediaPlanRequestComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '820px',
      minWidth:'820px',
      panelClass: 'cdk-overlay-panel-right-side',
      // data: mediaPlanRequest
    });
    this.createMediaPlanRequestComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.getListOfMediaPlan()
      }
    })
  }
  edit(mediaPlanRequest:any){
    // console.log(mediaPlanRequest)
    this.editMediaPlanRequestComponent = this.dialog.open(EditMediaPlanRequestComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '820px',
      minWidth:'820px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: mediaPlanRequest
    });
    this.editMediaPlanRequestComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.getListOfMediaPlan()
      }
    })
  }
  editMediaPlan(mediaPlan:any,mediaPlanRequest:any){
    // console.log(mediaPlanRequest)
    mediaPlan['mediaPlanRequest']=mediaPlanRequest
    this.editMediaPlanComponent = this.dialog.open(EditMediaPlanComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '820px',
      minWidth:'820px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: mediaPlan
    });
    this.editMediaPlanComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.getListOfMediaPlan()
      }
    })
  }
  getMediaPlanByMediaRequestId(index,item:any){
    // this.expandedIndex = this.expandedIndex === index ? null : index;
    const indexPosition = this.expandedRows.indexOf(index);
    if (indexPosition > -1) {
      // If index is already expanded, remove it (collapse row)
      this.expandedRows.splice(indexPosition, 1);
    } else {
      // Otherwise, add it to the array (expand row)
      this.expandedRows.push(index);
    }
  }
  isExpanded(index: number): boolean {
    return this.expandedRows.includes(index);
  }
  resetFilter(){
    this.createdAt = '';
    this.updatedAt = '';
    this.selectedStatus ='';
    this.selectedRequestType = '';
    this.selectedPriority = '';
    this.selectedPlanType ='';
    this.allIsActive = true;
    this.getListOfMediaPlan();

  }
  selectCreatedDate(event:any){ 
    if (event.formatted != undefined && event.formatted != "" && event.formatted != null) {
      this.createdAt = event
      this.getListOfMediaPlan('filter')
    } else {
      this.createdAt = undefined;
      this.getListOfMediaPlan('filter')
    }
  }
  selectUpdatedDate(event:any){ 
    if (event.formatted != undefined && event.formatted != "" && event.formatted != null) {
      this.updatedAt = event
      this.getListOfMediaPlan('filter')
    } else {
      this.updatedAt = undefined;
      this.getListOfMediaPlan('filter')
    }
  }
  getPriorityBackgroundColorStyle(item):any{
    if(item.toLowerCase() == 'low'){
      return '#F2F1E9'
    }
    else if(item.toLowerCase() == 'medium'){
      return '#F1EBD2'
    }
    else{
      return '#EFC9C0'
    }
  }
  createMediaPlan(data:any){
    if((data.assigned_user.id == this.userInfo.id ||  this.userInfo.admin) && (data.status.toLowerCase() != 'cancelled')){
    this.createMediaPlanComponent = this.dialog.open(CreateMediaPlanComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '820px',
      minWidth:'820px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: data
    });
    this.createMediaPlanComponent.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.showComponentLoader = true
        this.getListOfMediaPlan()
      }
    })
  }
  }
  downloadFile(data:any){
    this.showComponentLoader = true
    fetch(data.plan_sheet_link)
    .then(response => response.blob())
    .then(blob => {

        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = data.plan_sheet_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        this.showComponentLoader = false
    })
    .catch(error => console.error('Download error:', error));
  }
  viewMediaPlan(plans:any,media_request:any){
    plans['all_media_plan_request_data'] = media_request;
    this.viewMediaPlanComponent = this.dialog.open(ViewMediaPlanComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '820px',
      minWidth:'820px',
      panelClass: 'cdk-overlay-panel-right-side',
      data: plans
    });

  }
  viewMediaPlanRequest(data:any){
    // console.log(data)
    // this._router.navigate(['pages/view_media_plan_request'])
    this._router.navigate(['page/view_media_plan_request/' + data.id]);
    // plans = media_request;
    // this.viewMediaPlanRequestComponent = this.dialog.open(viewMediaPlanRequestComponent, {
    //   hasBackdrop: true,
    //   disableClose: false,
    //   autoFocus: true,
    //   width: '820px',
    //   minWidth:'820px',
    //   panelClass: 'cdk-overlay-panel-right-side',
    //   data: plans
    // });

  }
  changeMediaPlanRequestPlan(event:any,index:any){
  //  console.log()
    if(event.target.innerText.toLowerCase() == 'cancelled'){
      this.cancelledStatusComponent = this.dialog.open(CancelledStatusComponent, {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: '820px',
        minWidth:'820px',
        panelClass: 'cdk-overlay-panel',
        data: index
      });
      this.cancelledStatusComponent.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.showComponentLoader = true
          this.getListOfMediaPlan()
        }
      })
    }
    else{
    // return;
    let body={
      status:event.target.innerText
    }
    
    this._serverService.updateMediaPlanRequest(index,body,this.token).subscribe((data)=>{
      // console.log(data)
      this.getListOfMediaPlan()
    })
  }
}
  getstatusCss(status:any){
    switch(status.toLowerCase()){
      case 'approved':return {'border':'border: 0.5px solid #009F3F',color:'#006A00','background-color':'#F1FFF1','opacity':1}
      case 'cancelled':return {'border':'border: 0.5px solid #8B2A1D',color:'#8B2A1D','background-color':'#FFF7F6!important','opacity':0.5}
      default:return {'border':'border: 0.5px solid #878787',color:'#454545','background-color':'#F6F6F6','opacity':1}
    }
  }
}
